import { Chip } from "@mui/material";
import { getValueDisplay } from "../../data/utilities";
import { STATUS_AMBER, STATUS_GREEN, STATUS_GREY, STATUS_RED } from "../colors";

export const CompanyStatus = (props: { status: string | undefined }) => {
  let backgroundColor: string = STATUS_GREY;

  if (props.status === "active") {
    backgroundColor = STATUS_GREEN;
  } else if (props.status === "liquidation" || props.status === "insolvency-proceedings") {
    backgroundColor = STATUS_RED;
  } else if (props.status === "dissolved") {
    backgroundColor = STATUS_AMBER;
  }

  return (
    <Chip
      label={getValueDisplay(props.status)}
      size="small"
      style={{
        backgroundColor,
        color: "white",
        fontWeight: 600,
      }}
    />
  );
};
